import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import Accordion from 'client/components/aria/Accordion';
import AssetOwner from './AssetOwner/AssetOwner';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import { ASSET_TYPES } from 'client/utils/constants/assetTypes';
import { orderBy } from 'lodash';
import styles from 'client/pages/MapPage/components/MapMenu/AssetOwners/AssetOwner/AssetOwner.module.scss';
import { useSelector } from 'react-redux';

const AccordionContent = ({ title, content, ...props }) => {
    return (
        <Accordion title={title} data-testid={props['data-testid'] ? props['data-testid'] : null} titleClassName={styles.accordionHeading}>
            {orderBy(content, 'label', 'asc').map(owner =>
                <AssetOwner key={owner?.dataProviderId} details={owner}/>
            )}
        </Accordion>
    );
};

const AssetOwners = ({ assetsInAOIOwners, operationalZone, nationalOrRegional }) => {
    const intl = useIntl();
    const isNullOrEmpty = (array) => (!Array.isArray(array)) || array.length === 0;

    const assets = useSelector(state => state.assets);

    const assetsInAOIOwnersWithoutObservations = (assetsInAOIOwners || []).filter(asset => {
        const nonObservationLayers = Object.keys(assets.layers).filter(layerName => {
            return layerName !== ASSET_TYPES.OBSERVATION && assets.layers[layerName].find(feature => {
                return feature.values_.dataproviderid_fk === asset.dataProviderId;
            });
        });
        return nonObservationLayers.length > 0;
    });

    return (
        <div data-testid="mapPage.menu.assetOwners">
            {assetsInAOIOwnersWithoutObservations && assetsInAOIOwnersWithoutObservations.length > 0
                ? <AccordionContent
                    data-testid="assetOwners.menu.assetsInAOIOwners"
                    title={intl.formatMessage({ id: 'assetOwners.menu.assetsInAOIOwners' })}
                    content={assetsInAOIOwnersWithoutObservations}
                />
                : null
            }
            {operationalZone && operationalZone.length > 0
                ? <AccordionContent
                    data-testid="assetOwners.menu.operationalZones"
                    title={intl.formatMessage({ id: 'assetOwners.menu.operationalZones' })}
                    content={operationalZone}
                />
                : null
            }
            {nationalOrRegional && nationalOrRegional.length > 0
                ? <AccordionContent
                    data-testid="assetOwners.menu.nationalRegional"
                    title={intl.formatMessage({ id: 'assetOwners.menu.nationalRegional' })}
                    content={nationalOrRegional}
                />
                : null
            }
            {isNullOrEmpty(assetsInAOIOwners) && isNullOrEmpty(operationalZone) && isNullOrEmpty(nationalOrRegional)
                ? <div className={styles.assetOwners}>
                    <FormattedMessage id="assetOwners.noAssets.message"/>
                </div>
                : null
            }
        </div>
    );
};

AssetOwners.propTypes = {
    ...defaultAriaProps,
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        content: PropTypes.any
    }))
};

export default AssetOwners;
